export default __webpack_public_path__ + "static/media/wise-icon.e800657c.svg";